import { createReducer } from "redux-starter-kit";
import {
  changeArticleModeAction,
  setEditingArticleAction,
  snapShotEditArticleMetaAction,
  recoverLastEditArticleMetaAction,
  updateArticleMetaTextAction,
  recoverLastEditArticleContentAction,
  updateArticleMetaContributorNamesAction,
  setLockingIDAction,
  apiSetACDTextAction,
  setACDItemAction,
  appendContentACDItemAction,
  appendContentACDItemNoRecoverAction,
  deleteContentAction,
  snapShotEditArticleContentAction,
  updateArticleContentTextAction,
  createManualItemAction,
  setPreviewOffsetAction,
  pushContributorNameAction,
  deleteContributorNameAction,
  inserImageArrAction,
  deleteImageArrAction,
  setSubLockingIDAction,
  setACDSubItemAction,
  apiSetACDSubItemTextAction,
  updateArticleContentSubTextAction,
  setPreviewingTextLineIDs,
  setPreviewingImageIDs,
  setPreviewingItemHidingMode,
  setAllPreviewingItemHidingMode
} from "../actions/editArticlePanel";

import {
  prepareMetaACDItemForClient,
  prepareCommonACDItemForClient
} from "../../api/apiUtils";

import {
  ACDTYPE_TEXT_ONLY,
  ACDTYPE_TEXT,
  ACDTYPE_IMAGE_ONLY,
  ACDTYPE_IMAGE
} from "../../model/ACDTypes";
import {
  ACSTYPE_PARAGRAPH,
  ACSTYPE_TITLE,
  ACSTYPE_SUBTITLE,
  ACSTYPE_INTRO,
  ACSTYPE_CONTRIBUTOR,
  ACSTYPE_SEP,
  ACSTYPE_MAIN_IMG,
  ACSTYPE_IMAGE
} from "../../model/ACSTypes";

const INIT_STATE = {
  articleID: null,
  blocking: false,
  metaEditHistory: [
    /* {  }, ... */
  ],
  contentEditHistory: [
    /* { itemIDs: [], itemsDict: {} }, ... */
  ],
  contentLastAppendTime: null,

  lockingID: null,
  subLockingID: null,
  mode: "meta",
  previewOffset: 0,
  previewingTextLineIDs: null,
  previewingImageIDs: null,
  previewHidingItemIDs: {}
};

const RECOVER_STEP_LIMIT = 6;

const editArticlePanel = createReducer(INIT_STATE, {
  [changeArticleModeAction]: (state, action) => {
    state.lockingID = action.payload.lockingID;
    state.subLockingID = null;
    state.mode = action.payload.mode;
  },
  [setPreviewOffsetAction]: (state, action) => {
    state.previewOffset = action.payload.previewOffset;
  },
  [setPreviewingTextLineIDs]: (state, action) => {
    state.previewingTextLineIDs = action.payload.textLineIDs;
  },
  [setPreviewingImageIDs]: (state, action) => {
    state.previewingImageIDs = action.payload.imageIDs;
  },
  [setPreviewingItemHidingMode]: (state, action) => {
    state.previewHidingItemIDs[action.payload.id] = action.payload.mode;
  },
  [setAllPreviewingItemHidingMode]: (state, action) => {
    const { itemIDs } = state.contentEditHistory[
      state.contentEditHistory.length - 1
    ];

    const articleID = state.articleID;

    const titleID = articleID + "-TITLE";
    const subtitleID = articleID + "-SUBTITLE";
    const contributorID = articleID + "-CONTRIBUTOR";

    state.previewHidingItemIDs = {};
    itemIDs.map(anID => {
      state.previewHidingItemIDs[anID] = action.payload.mode;
      return anID;
    });

    state.previewHidingItemIDs[titleID] = action.payload.mode;
    state.previewHidingItemIDs[subtitleID] = action.payload.mode;
    state.previewHidingItemIDs[contributorID] = action.payload.mode;
  },
  [setEditingArticleAction]: (state, action) => {
    state.contentLastAppendTime = null;
    state.lockingID = null;
    state.subLockingID = null;
    state.mode = "meta";
    state.previewHidingItemIDs = {};
    state.previewOffset = 0;

    const article = action.payload.article;
    const components = action.payload.components.components;

    state.articleID = article.id;
    state.blocking = false;

    const titleID = article.id + "-TITLE";
    const subtitleID = article.id + "-SUBTITLE";
    const contributorID = article.id + "-CONTRIBUTOR";
    const introID = article.id + "-INTRO";
    const mainImgID = article.id + "-MAIN_IMG";

    let metaDict = {};

    /*console.log("from API:");
    console.log(components);
    console.log("=========");*/

    metaDict[titleID] = prepareMetaACDItemForClient(
      components.title,
      titleID,
      ACDTYPE_TEXT_ONLY,
      ACSTYPE_TITLE
    );
    metaDict[subtitleID] = prepareMetaACDItemForClient(
      components.subtitle,
      subtitleID,
      ACDTYPE_TEXT_ONLY,
      ACSTYPE_SUBTITLE
    );
    metaDict[introID] = prepareMetaACDItemForClient(
      components.intro,
      introID,
      ACDTYPE_TEXT_ONLY,
      ACSTYPE_INTRO
    );
    metaDict[contributorID] = prepareMetaACDItemForClient(
      components.contributor,
      contributorID,
      ACDTYPE_TEXT_ONLY,
      ACSTYPE_CONTRIBUTOR
    );
    metaDict[mainImgID] = prepareMetaACDItemForClient(
      components.main_image,
      mainImgID,
      ACDTYPE_IMAGE_ONLY,
      ACSTYPE_MAIN_IMG
    );

    state.metaEditHistory = [metaDict];

    let acdItems = [];
    try {
      acdItems = components.sections.map(aCommonACDItem =>
        prepareCommonACDItemForClient(aCommonACDItem)
      );
    } catch (e) {
      state.blocking = true;
      acdItems = [
        {
          id: "ERROR_ITEM",
          text: "ERROR: " + e.toString(),
          isTextServerProcessed: true,
          textLineIDs: null,
          dataType: ACDTYPE_TEXT,
          styleType: ACSTYPE_PARAGRAPH
        }
      ];
    }

    const itemIDs = acdItems.map(anItem => anItem.id);
    let itemsDict = {};

    for (let i = 0; i < acdItems.length; i++) {
      itemsDict[acdItems[i].id] = acdItems[i];
    }

    state.contentEditHistory = [
      {
        itemIDs,
        itemsDict
      }
    ];
  },
  [pushContributorNameAction]: (state, action) => {
    const metaDict = state.metaEditHistory[state.metaEditHistory.length - 1];
    const newMetaDict = { ...metaDict };

    const id = action.payload.id;
    const data = JSON.parse(JSON.stringify(newMetaDict[id]));

    const idx = action.payload.index;

    if (data != null) {
      data.names[idx].name.push("");
    }

    newMetaDict[id] = data;
    state.metaEditHistory.push(newMetaDict);

    if (state.metaEditHistory.length > RECOVER_STEP_LIMIT) {
      state.metaEditHistory.shift();
    }
  },
  [deleteContributorNameAction]: (state, action) => {
    const metaDict = state.metaEditHistory[state.metaEditHistory.length - 1];
    const newMetaDict = { ...metaDict };

    const id = action.payload.id;
    const data = JSON.parse(JSON.stringify(newMetaDict[id]));

    const idx = action.payload.index;
    const arrayIdx = action.payload.arrayIdx;

    if (data != null) {
      if (arrayIdx < data.names[idx].name.length) {
        data.names[idx].name.splice(arrayIdx, 1);
      }
    }

    newMetaDict[id] = data;
    state.metaEditHistory.push(newMetaDict);

    if (state.metaEditHistory.length > RECOVER_STEP_LIMIT) {
      state.metaEditHistory.shift();
    }
  },
  [updateArticleContentTextAction]: (state, action) => {
    const { itemsDict } = state.contentEditHistory[
      state.contentEditHistory.length - 1
    ];

    const id = action.payload.id;
    const data = itemsDict[id];

    if (data != null) {
      data.text = action.payload.text;
    }
  },
  [snapShotEditArticleContentAction]: (state, action) => {
    const { itemIDs, itemsDict } = state.contentEditHistory[
      state.contentEditHistory.length - 1
    ];

    let newDict = { ...itemsDict };

    if (
      action.payload != null &&
      action.payload.id != null &&
      action.payload.subID != null
    ) {
      let newItem = { ...newDict[action.payload.id] };

      newDict[action.payload.id] = newItem;

      let imageItemArr = newItem.imageItemArr;

      if (imageItemArr != null) {
        let newImageItemArr = [...imageItemArr];

        let toItemIdx = newImageItemArr.findIndex(
          item => item.id === action.payload.subID
        );

        if (toItemIdx >= 0) {
          newImageItemArr[toItemIdx] = { ...newImageItemArr[toItemIdx] };
          newItem.imageItemArr = newImageItemArr;
        }
      }
    }

    const newHistory = {
      itemIDs: [...itemIDs],
      itemsDict: newDict
    };

    state.contentEditHistory.push(newHistory);

    if (state.contentEditHistory.length > RECOVER_STEP_LIMIT) {
      state.contentEditHistory.shift();
    }
  },
  [snapShotEditArticleMetaAction]: (state, action) => {
    const metaDict = state.metaEditHistory[state.metaEditHistory.length - 1];

    const newMetaDict = { ...metaDict };

    state.metaEditHistory.push(newMetaDict);

    if (state.metaEditHistory.length > RECOVER_STEP_LIMIT) {
      state.metaEditHistory.shift();
    }
  },
  [recoverLastEditArticleMetaAction]: (state, action) => {
    if (state.metaEditHistory.length > 1) {
      state.metaEditHistory.pop();
    }
  },
  [createManualItemAction]: (state, action) => {
    const newID = action.payload.newID;
    let insertIndex = action.payload.insertIndex;

    const curSnapshot =
      state.contentEditHistory[state.contentEditHistory.length - 1];

    const { itemsDict, itemIDs } = curSnapshot;

    insertIndex = insertIndex < 0 ? 0 : insertIndex;
    insertIndex = insertIndex > itemIDs.length ? itemIDs.length : insertIndex;

    let newDict = { ...itemsDict };
    let newArr = [...itemIDs];

    newArr.splice(insertIndex, 0, newID);

    newDict[newID] = {
      id: newID,
      text: "",
      isTextServerProcessed: true,
      textLineIDs: null,
      dataType: action.payload.type,
      styleType:
        action.payload.type === ACDTYPE_TEXT ? ACSTYPE_PARAGRAPH : ACSTYPE_SEP
    };

    if (action.payload.type === ACDTYPE_IMAGE) {
      newDict[newID].image = { id: action.payload.imageID };
      newDict[newID].styleType = ACSTYPE_IMAGE;
    }

    const newHistory = {
      itemIDs: newArr,
      itemsDict: newDict
    };

    state.contentEditHistory.push(newHistory);

    if (state.contentEditHistory.length > RECOVER_STEP_LIMIT) {
      state.contentEditHistory.shift();
    }
  },
  [recoverLastEditArticleContentAction]: (state, action) => {
    if (state.contentEditHistory.length > 1) {
      state.contentEditHistory.pop();
    }
  },
  [updateArticleMetaTextAction]: (state, action) => {
    const metaDict = state.metaEditHistory[state.metaEditHistory.length - 1];

    const id = action.payload.id;
    const data = metaDict[id];

    if (data != null) {
      data.text = action.payload.text;
    }
  },
  [updateArticleMetaContributorNamesAction]: (state, action) => {
    const metaDict = state.metaEditHistory[state.metaEditHistory.length - 1];

    const id = action.payload.id;
    const data = metaDict[id];

    const idx = action.payload.index;
    const arrayIdx = action.payload.arrayIdx;

    if (data != null) {
      if (action.payload.typeOrName === "name") {
        if (arrayIdx < data.names[idx].name.length) {
          data.names[idx].name[arrayIdx] = action.payload.text;
        }
      } else {
        data.names[idx].type = action.payload.text;
      }
    }
  },
  [setLockingIDAction]: (state, action) => {
    state.lockingID = action.payload.lockingID;
    state.subLockingID = null;
  },
  [setSubLockingIDAction]: (state, action) => {
    state.lockingID = action.payload.lockingID;
    state.subLockingID = action.payload.subLockingID;
  },
  [appendContentACDItemNoRecoverAction]: (state, action) => {
    const { itemIDs, itemsDict } = state.contentEditHistory[
      state.contentEditHistory.length - 1
    ];

    const newID = action.payload.newID;
    const timeStamp = action.payload.timeStamp;

    const newItem = {
      id: newID,
      text: "",
      image: action.payload.image,
      media: action.payload.media,
      isTextServerProcessed: false,
      textLineIDs: action.payload.textLineIDs,
      dataType: action.payload.dataType,
      styleType: action.payload.styleType
    };

    itemIDs.push(newID);
    itemsDict[newID] = newItem;

    state.contentLastAppendTime = timeStamp;
  },
  [appendContentACDItemAction]: (state, action) => {
    const { itemIDs, itemsDict } = state.contentEditHistory[
      state.contentEditHistory.length - 1
    ];

    const newID = action.payload.newID;
    const timeStamp = action.payload.timeStamp;

    const newItem = {
      id: newID,
      text: "",
      image: action.payload.image,
      media: action.payload.media,
      isTextServerProcessed: false,
      textLineIDs: action.payload.textLineIDs,
      dataType: action.payload.dataType,
      styleType: action.payload.styleType
    };

    let newDict = { ...itemsDict };
    newDict[newID] = newItem;

    const newHistory = {
      itemIDs: [...itemIDs, newID],
      itemsDict: newDict
    };

    state.contentEditHistory.push(newHistory);

    if (state.contentEditHistory.length > RECOVER_STEP_LIMIT) {
      state.contentEditHistory.shift();
    }

    state.contentLastAppendTime = timeStamp;
  },
  [apiSetACDTextAction]: (state, action) => {
    if (action.payload.mode === "meta") {
      const metaDict = state.metaEditHistory[state.metaEditHistory.length - 1];

      const anACDItem = metaDict[action.payload.id];

      if (anACDItem == null) {
        return;
      }

      anACDItem.text = action.payload.text;
      anACDItem.isTextServerProcessed = action.payload.ready;

      if (action.payload.orderedTextLineIDs != null) {
        anACDItem.orderedTextLineIDs = action.payload.orderedTextLineIDs;
      }
    } else if (action.payload.mode === "edit") {
      const curSnapshot =
        state.contentEditHistory[state.contentEditHistory.length - 1];
      const metaDict = curSnapshot.itemsDict;

      const anACDItem = metaDict[action.payload.id];

      if (anACDItem == null) {
        return;
      }

      anACDItem.text = action.payload.text;
      anACDItem.isTextServerProcessed = action.payload.ready;
    }
  },
  [deleteContentAction]: (state, action) => {
    const snapshot =
      state.contentEditHistory[state.contentEditHistory.length - 1];

    const { itemIDs, itemsDict } = snapshot;

    const idToBeDeleted = action.payload.id;
    if (action.payload.canRecover) {
      let newDict = { ...itemsDict };

      delete newDict[idToBeDeleted];

      const newHistory = {
        itemIDs: itemIDs.filter(anItemID => anItemID !== idToBeDeleted),
        itemsDict: newDict
      };

      state.contentEditHistory.push(newHistory);

      if (state.contentEditHistory.length > RECOVER_STEP_LIMIT) {
        state.contentEditHistory.shift();
      }
    } else {
      delete itemsDict[idToBeDeleted];
      snapshot.itemIDs = itemIDs.filter(anItemID => anItemID !== idToBeDeleted);
    }

    if (idToBeDeleted === state.lockingID) {
      state.lockingID = null;
      state.subLockingID = null;
    }
  },
  [setACDItemAction]: (state, action) => {
    if (action.payload.mode === "meta") {
      const metaDict = state.metaEditHistory[state.metaEditHistory.length - 1];
      const newMetaDict = { ...metaDict };

      newMetaDict[action.payload.id] = action.payload.item;
      state.metaEditHistory.push(newMetaDict);

      if (state.metaEditHistory.length > RECOVER_STEP_LIMIT) {
        state.metaEditHistory.shift();
      }
    } else if (action.payload.mode === "edit") {
      const curSnapshot =
        state.contentEditHistory[state.contentEditHistory.length - 1];

      let newDict = { ...curSnapshot.itemsDict };

      newDict[action.payload.id] = action.payload.item;

      const newSnapshot = {
        itemIDs: curSnapshot.itemIDs,
        itemsDict: newDict
      };

      state.contentEditHistory.push(newSnapshot);

      if (state.contentEditHistory.length > RECOVER_STEP_LIMIT) {
        state.contentEditHistory.shift();
      }
    }
  },
  [inserImageArrAction]: (state, action) => {
    const curSnapshot =
      state.contentEditHistory[state.contentEditHistory.length - 1];

    let newDict = { ...curSnapshot.itemsDict };
    let newItem = { ...newDict[action.payload.id] };

    newDict[action.payload.id] = newItem;

    let imageItemArr = newItem.imageItemArr;

    if (imageItemArr == null) {
      return;
    }

    let newImageItemArr = [...imageItemArr];

    let fromItemIdx = newImageItemArr.findIndex(
      item => item.id === action.payload.fromItemID
    );
    let toItemIdx = newImageItemArr.findIndex(
      item => item.id === action.payload.toItemID
    );

    if (fromItemIdx < 0 || toItemIdx < 0 || fromItemIdx === toItemIdx - 1) {
      return;
    }

    let movingImageItem = newImageItemArr[fromItemIdx];

    newImageItemArr.splice(fromItemIdx, 1);
    toItemIdx = newImageItemArr.findIndex(
      item => item.id === action.payload.toItemID
    );

    newImageItemArr.splice(toItemIdx, 0, movingImageItem);
    newItem.imageItemArr = newImageItemArr;

    const newHistory = {
      itemIDs: curSnapshot.itemIDs,
      itemsDict: newDict
    };

    state.contentEditHistory.push(newHistory);

    if (state.contentEditHistory.length > RECOVER_STEP_LIMIT) {
      state.contentEditHistory.shift();
    }
  },
  [deleteImageArrAction]: (state, action) => {
    const curSnapshot =
      state.contentEditHistory[state.contentEditHistory.length - 1];

    let newDict = { ...curSnapshot.itemsDict };
    let newItem = { ...newDict[action.payload.id] };

    newDict[action.payload.id] = newItem;

    let imageItemArr = newItem.imageItemArr;
    let deleteImageID = action.payload.deleteImageID;

    if (imageItemArr == null || deleteImageID == null) {
      return;
    }

    let newImageItemArr = imageItemArr.filter(
      anImageItem => anImageItem.id !== deleteImageID
    );
    newItem.imageItemArr = newImageItemArr;

    let newHistory = {};

    if (newImageItemArr.length <= 0) {
      delete newDict[action.payload.id];

      newHistory = {
        itemIDs: curSnapshot.itemIDs.filter(
          anItemID => anItemID !== action.payload.id
        ),
        itemsDict: newDict
      };
    } else if (newImageItemArr.length === 1) {
      delete newDict[action.payload.id];
      newDict[newImageItemArr[0].id] = newImageItemArr[0];

      const itemIdx = curSnapshot.itemIDs.indexOf(action.payload.id);
      const newItemIds = [...curSnapshot.itemIDs];
      newItemIds.splice(itemIdx, 1, newImageItemArr[0].id);

      newHistory = {
        itemIDs: newItemIds,
        itemsDict: newDict
      };
    } else {
      newHistory = {
        itemIDs: curSnapshot.itemIDs,
        itemsDict: newDict
      };
    }

    state.contentEditHistory.push(newHistory);

    if (state.contentEditHistory.length > RECOVER_STEP_LIMIT) {
      state.contentEditHistory.shift();
    }

    if (deleteImageID === state.subLockingID) {
      state.lockingID = null;
      state.subLockingID = null;
    }
  },
  [setACDSubItemAction]: (state, action) => {
    const curSnapshot =
      state.contentEditHistory[state.contentEditHistory.length - 1];

    let newDict = { ...curSnapshot.itemsDict };
    let newItem = { ...newDict[action.payload.id] };

    newDict[action.payload.id] = newItem;

    let imageItemArr = newItem.imageItemArr;

    if (imageItemArr == null) {
      return;
    }

    let newImageItemArr = [...imageItemArr];

    let toItemIdx = newImageItemArr.findIndex(
      item => item.id === action.payload.subID
    );

    if (toItemIdx < 0) {
      return;
    }

    newImageItemArr[toItemIdx] = action.payload.item;
    newItem.imageItemArr = newImageItemArr;

    const newHistory = {
      itemIDs: curSnapshot.itemIDs,
      itemsDict: newDict
    };

    state.contentEditHistory.push(newHistory);

    if (state.contentEditHistory.length > RECOVER_STEP_LIMIT) {
      state.contentEditHistory.shift();
    }
  },
  [updateArticleContentSubTextAction]: (state, action) => {
    const curSnapshot =
      state.contentEditHistory[state.contentEditHistory.length - 1];

    let mainItem = curSnapshot.itemsDict[action.payload.id];

    if (mainItem == null) {
      return;
    }

    if (mainItem.imageItemArr == null) {
      return;
    }

    let toItemIdx = mainItem.imageItemArr.findIndex(
      item => item.id === action.payload.subID
    );

    if (toItemIdx < 0) {
      return;
    }

    const subItem = mainItem.imageItemArr[toItemIdx];
    subItem.text = action.payload.text;
  },
  [apiSetACDSubItemTextAction]: (state, action) => {
    const curSnapshot =
      state.contentEditHistory[state.contentEditHistory.length - 1];

    let mainItem = curSnapshot.itemsDict[action.payload.id];

    if (mainItem == null) {
      return;
    }

    if (mainItem.imageItemArr == null) {
      return;
    }

    let toItemIdx = mainItem.imageItemArr.findIndex(
      item => item.id === action.payload.subID
    );

    if (toItemIdx < 0) {
      return;
    }

    const subItem = mainItem.imageItemArr[toItemIdx];
    subItem.text = action.payload.text;
    subItem.isTextServerProcessed = action.payload.ready;

    if (action.payload.orderedTextLineIDs != null) {
      subItem.orderedTextLineIDs = action.payload.orderedTextLineIDs;
    }
  }
});

export default editArticlePanel;
